<template>
    <VJoyWrapper class="recomendations-count" column-gap="2">
        <VJoyAvatarsList :compress="true">
            <VJoyAvatar
                v-for="recommendation in acceptedRecommendations"
                :key="`recommendation_avatar_${recommendation.accountId}`"
                size="small"
                :full-name="`${escapeHtml(recommendation.authorFirstName)} ${escapeHtml(recommendation.authorLastName)}`"
            />
        </VJoyAvatarsList>
        <!-- eslint-disable vue/no-v-html -->
        <p
            class="recommendations-count__text"
            v-html="
                $t('profile.section.recommendation.authors.count.v2', {
                    recommendationsCount,
                    recommenderFullName: `${escapeHtml(acceptedRecommendations[0].authorFirstName)} ${escapeHtml(
                        acceptedRecommendations[0].authorLastName,
                    )}`,
                    freelancerFirstName: escapeHtml(profileFirstname),
                })
            "
        ></p>
        <!-- eslint-enable vue/no-v-html -->
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {escapeHtml} from '@malt/sanitize';
    import {VJoyAvatar, VJoyAvatarsList, VJoyWrapper} from '@maltjoy/core-vue';
    import type {Recommendation} from '~/types/domain/Recommendations';

    defineProps<{
        acceptedRecommendations: Recommendation[];
        recommendationsCount: number;
        profileFirstname: string;
    }>();
</script>

<style scoped lang="scss">
    .recommendations-count {
        margin-bottom: var(--joy-core-spacing-4);

        &__text {
            font-size: var(--joy-font-size-primary-400);
            color: var(--joy-color-text-body);
            &:deep(a) {
                color: var(--joy-color-secondary-30);
                font-weight: var(--joy-font-weight-bold);
            }
        }
    }
</style>
